var urler = require("./url.js")
var jsonp = require("./jsonp.js")
var resources = {}
var resourcesStatus = {}
//jsonp 和 ajax 请求封装

function SimplePromise(){
  this.request = null
  this.successCall = null
  this.success = function(cb){
    this.successCall=cb;
    return this;
  }
  this.errorCall = null
  this.error = function(cb){
    this.errorCall=cb;
    return this;
  }
}

function sendGubawebapi(url,param){
  var urlmain = "http://iguba.eastmoney.com/gubaapi/v3/"
  var params = {
    pi: 'ecp',
    isweb: true,
    deviceid: '',
    version: '3.1.1',
    product: 'Guba',
    plat: 'Web'
  };
   for(var prob in param){
    params[prob] = param[prob]
   }
  return jsonp(urlmain+url, params, 'jsonp');
}

// function jsonp(url,param,dataType){
//   var promise = new SimplePromise()
//   var dataType = dataType?dataType:'jsonp';
//   var url = url
//   $.ajax({
//     type: "GET",
//     url: url,
//     dataType: dataType,
//     data: param,
//     success: function (data) {
//       if(promise.successCall){//业务逻辑成功
//         promise.successCall(data);
//       }
//     },
//     error : function (){
//     }
//   });
//
//
//   return promise
// }

function getjsonp(route,param){
  var simplePromise = {
    successCall:null,
    success:function(cb){
      simplePromise.successCall=cb;
      return simplePromise;
    },
    errorCall:null,
    error:function(cb){
      simplePromise.errorCall=cb;
      return simplePromise;
    }
  };
  // var host = getApiHost(route);
  if(route.indexOf("://")==-1){
    if(window.embedHelper.env.isRelease){
      // route = "" + route;
      route = "https://gubaapi4apphttps.eastmoney.com" + route;
    }else{
      if(route.indexOf("https://")>-1 || route.indexOf("http://")>-1){
        route = route;
      }else{
        route = "http://gubaapi4app-test.eastmoney.com" + route;
      }
    }
  }
  var version = window.embedHelper.url.GetQueryString("version")?window.embedHelper.url.GetQueryString("version"):'0';
  var plat = window.embedHelper.url.GetQueryString("plat")?window.embedHelper.url.GetQueryString("plat"):'iphone';

  var url = route+'?deviceid=1&version='+version+'&product=EastMoney&plat='+plat+'&mt='+Math.random();

  if(window.embedHelper.user.isLogin()){
    param = Object.assign({},param,{
      "ctoken":window.embedHelper.user.ct,
      "utoken":window.embedHelper.user.ut
    })
  }
  jsonp.get(url,param,
  function(data){
    if(data){
      var json = data;
      if(json.rc==1||json.code==0){
        if(simplePromise.successCall){//业务逻辑成功
          simplePromise.successCall(json);
        }
      }else{
        // if(json.me == "您尚未登录，请登录后使用"){
        //   helper.observer.trigger("confirm",json.me,1);
        // }
        if(simplePromise.errorCall){	//业务逻辑错误
          if(json.error_code === 19 || json.error_code === 41){ //如果当前用户被禁言(error_code == 19), 则弹出下面弹窗
              json.me = "您已被禁言，请登录东方财富APP申请解禁";
          }
          simplePromise.errorCall(json.me,json);
        }
      }
    }
  });
  return simplePromise;
}
function getjsonp_core(options){
  //alert(options)
  //-1. 整理options
  options = options || {};
  if(!options.url) return;
  options.data = options.data || {};
  options.type = options.type || 'get';
  options.timeout = options.timeout || 0;

  if(options.url.indexOf("http://")==-1){
      if(window.embedHelper.env.isRelease){
        options.url = "https://gbapi.eastmoney.com" + options.url;
      }else{
        options.url = "http://gbapi-test.eastmoney.com" + options.url;
      }

  }
  options.data = Object.assign({},options.data,{
    "ctoken":window.embedHelper.user.ct,
    "utoken":window.embedHelper.user.ut,
    "deviceid": 1,
    "version":window.embedHelper.url.GetQueryString("version")?window.embedHelper.url.GetQueryString("version"):(window.data?window.data.version:""),
    "product":window.embedHelper.url.GetQueryString("product")?window.embedHelper.url.GetQueryString("product"):(window.data?window.data.product:"EastMoney"),
    "plat":window.embedHelper.url.GetQueryString("plat")?window.embedHelper.url.GetQueryString("plat"):(window.data?window.data.plat:"iphone"),
    "pi":'1'
  })
  //0.整理data
  options.data.t=Math.random();

  var arr=[];
  for(var key in options.data){
    arr.push(key+'='+encodeURIComponent(options.data[key]));
  }
  var str = arr.join('&');

  //1.创建ajax  //readyState:0 (未初始化): 请求已建立, 但未初始化(此时未调用open方法),对应常量 oAjax.UNSENT
  if(window.XMLHttpRequest){
    var oAjax=new XMLHttpRequest();
  }else{
    //var oAjax=new ActiveXObject('Microsoft.XMLHTTP');
    //ie6及以下
    try {
        var oAjax = new ActiveXObject("Msxml2.XMLHTTP");//即MSXML3
      } catch (e) {
          try {
            var oAjax = new ActiveXObject("Microsoft.XMLHTTP");//很老的api,虽然浏览器支持,功能可能不完善,故不建议使用
          } catch (e) {
            alert("您的浏览器暂不支持Ajax!");
          }
      }
  }
  if(options.type=='get'){//根据type建立连接，发送请求
    //2.
    oAjax.open('get',options.url+'?'+str,true);
    //readyState: 1(初始化): 请求已建立, 但未发送 (已调用open方法, 但未调用send方法),对应常量 oAjax.OPENED
    //3.
    oAjax.send();
    //readyState: 2(发送数据):请求已发送 (send方法已调用, 已收到响应头),对应常量 oAjax.HEADERS_RECEIVED

    //readyState: 3 (数据传送中):请求处理中, 因响应内容不全, 这时通过responseBody和responseText获取可能会出现错误,对应常量 oAjax.LOADING

    //readyState: 4 (完成):数据接收完毕, 此时可以通过通过responseBody和responseText获取完整的响应数据,对应常量 oAjax.DONE
  }else{
    //2.
    oAjax.open('post',options.url,true);
    //设置请求头信息
    oAjax.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    //3.
    oAjax.send(str);
  }

  
  //4.接收
  if(options.sendtype == 'normal'){
    oAjax.onreadystatechange=function(){
      if(oAjax.readyState==4){
        clearTimeout(timer);
        if(oAjax.status>=200 && oAjax.status<300 || oAjax.status==304){
          options.success && options.success(oAjax.responseText);
        }else{
          options.error && options.error(oAjax.status);
        }
      }
    };
  }else{
      oAjax.onreadystatechange=function(){
      if(oAjax.readyState==4){
        clearTimeout(timer);
        if(oAjax.status>=200 && oAjax.status<300 || oAjax.status==304){
          if(JSON.parse(oAjax.responseText).rc == 1){
            options.success && options.success(JSON.parse(oAjax.responseText));
          }else{
            options.error && options.error(oAjax.status);
          }
        }else{
          options.error && options.error(oAjax.status);
        }
      }
    };
  }
  

  //5.超时
  if(options.timeout){
    var timer=setTimeout(function(){
      alert('超时了');
      oAjax.abort();//中断ajax请求
    },options.timeout);
  }
}

function esJsonp(options){
  //整理options
  options = options ||  {};
  if(!options.url) return;
  if(!options.data) return;
  options.cbKey=  options.cbKey || 'cb';
  options.timeout=options.timeout ||  0;
  options.success=options.success ||  null;
  options.error=options.error ||  null;

  //整理data
  var cbValue =  'jsonp'+Math.random();
  options.data[options.cbKey]=cbValue.replace('.','');//告诉网上的js回调随机函数名

  window[options.data[options.cbKey]]=function(json){
    options.success && options.success(json);
    clearTimeout(timer);
    //删除script标签
    document.getElementsByTagName('head')[0].removeChild(oSc);
    window[options.data[options.cbKey]]=null;//删除用过的函数
  };

  var arr=[];
  for(var key in options.data){
    arr.push(key+'='+encodeURIComponent(options.data[key]));
  }
  options.url = options.url +'?' +arr.join('&');
  //创建script标签，丢到head里面
  var oSc=document.createElement('script');
  oSc.src=options.url;
  document.getElementsByTagName('head')[0].appendChild(oSc);

  //超时
  if(options.timeout){
    var timer=setTimeout(function(){
      options.error && options.error();
      //阻止请求
      window[options.data[options.cbKey]]=function(){};//给个空函数什么都不做
      document.getElementsByTagName('head')[0].removeChild(oSc);
      //alert('tiemout')
    },options.timeout);

  }
}

function send(url,param){
  var realUrl = url;
  if(window.embedHelper.env.isDevelop){//本机情况下发送latte假服务器
    realUrl = window.location.protocol+"//"+window.location.hostname+":"+(window.location.port*1+2)+"/transfer";
    if(url.indexOf("\/")==0){
      url = "http://guba.eastmoney.com"+url;
    }
    param = $.extend(true, {remote:url} ,param||{})
    return jsonp(realUrl,param);
  }
  return ajax(realUrl,param);
}

function ajax(url,param){
  var promise = new SimplePromise()
  var url = url
  $.ajax({
    type: "POST",
    url: url,
    dataType: "json",
    data: param,
    success: function (data) {
      if(promise.successCall){//业务逻辑成功
        promise.successCall(data);
      }
    },
    error : function (res){
      if(promise.errorCall){//接口调用失败
        promise.errorCall(res);
      }
    }
  });

  return promise
}

var load = {
    $$:function(id){return document.getElementById(id)},
    tag:function(element){return document.getElementsByTagName(element)},
    ce:function(element){return document.createElement(element)},
    resource:function(filename,type,callback)
    {
      var url = filename;
      // if (window.location.href.indexOf("mcs.guba.east")>=1 || window.location.href.indexOf("gubatestapi.eastmoney.com")>=1 || window.location.href.indexOf("61.129.249.69")>=1) {
      //   url = "http://gubawebcs.eastmoney.com/app_embed/test/"+filename;
      // }else if(window.location.href.indexOf("127.0.0.1")>=1){
      //   url = filename;
      // }else {
      //   url = "http://gbfek.dfcfw.com/gubaapi/app_embed/"+filename;
      // }
      function ready(){
          // if (s.readyState == 'loaded' || s.readyState == 'complete') {
              callback();
          // }
      };

      if (type == 'script') {
        s = load.ce('script');
        s.type = "text/javascript";
        s.onreadystatechange = ready;
        s.onerror = s.onload = callback;
        s.onload = ready;
        s.src = url;
        load.tag('head')[0].appendChild(s);
      } else {
        s = load.ce('link');
        s.type = "text/css";
        s.rel = 'stylesheet';
        s.onreadystatechange = ready;
        s.onload = ready;
        s.onerror = s.onload = callback;
        s.href = url;
        load.tag('head')[0].appendChild(s);
      }


    }
}

// function loadResource(filename,type,callback){
//   load.resource(filename,type,callback)
// }


// var host = getApiHost(route);

function esAjax(options){

  //-1. 整理options
  options = options || {};
  if(!options.url) return;
  options.data = options.data || {};
  options.type = options.type || 'get';
  options.timeout = options.timeout || 0;

  if(options.url.indexOf("http://")==-1){
      if(window.embedHelper.env.isRelease){
        options.url = "https://gubaapi4apphttps.eastmoney.com" + options.url;
      }else{
        options.url = "http://gubaapi4app-test.eastmoney.com" + options.url;
      }
  }
  options.data = Object.assign({},options.data,{
    "ctoken":window.embedHelper.user.ct,
    "utoken":window.embedHelper.user.ut,
    deviceid: 90000,
    version:200,
    product:'Guba',
    plat:'Iphone',
    pi:'1'
  })
  //0.整理data
  options.data.t=Math.random();

  var arr=[];
  for(var key in options.data){
    arr.push(key+'='+encodeURIComponent(options.data[key]));
  }
  var str = arr.join('&');

  //1.创建ajax  //readyState:0 (未初始化): 请求已建立, 但未初始化(此时未调用open方法),对应常量 oAjax.UNSENT
  if(window.XMLHttpRequest){
    var oAjax=new XMLHttpRequest();
  }else{
    //var oAjax=new ActiveXObject('Microsoft.XMLHTTP');
    //ie6及以下
    try {
        var oAjax = new ActiveXObject("Msxml2.XMLHTTP");//即MSXML3
      } catch (e) {
          try {
            var oAjax = new ActiveXObject("Microsoft.XMLHTTP");//很老的api,虽然浏览器支持,功能可能不完善,故不建议使用
          } catch (e) {
            alert("您的浏览器暂不支持Ajax!");
          }
      }
  }

  if(options.type=='get'){//根据type建立连接，发送请求
    //2.
    oAjax.open('get',options.url+'?'+str,true);
    //readyState: 1(初始化): 请求已建立, 但未发送 (已调用open方法, 但未调用send方法),对应常量 oAjax.OPENED
    //3.
    oAjax.send();
    //readyState: 2(发送数据):请求已发送 (send方法已调用, 已收到响应头),对应常量 oAjax.HEADERS_RECEIVED

    //readyState: 3 (数据传送中):请求处理中, 因响应内容不全, 这时通过responseBody和responseText获取可能会出现错误,对应常量 oAjax.LOADING

    //readyState: 4 (完成):数据接收完毕, 此时可以通过通过responseBody和responseText获取完整的响应数据,对应常量 oAjax.DONE
  }else{
    //2.
    oAjax.open('post',options.url,true);
    //设置请求头信息
    oAjax.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    //3.
    oAjax.send(str);
  }


  //4.接收
  oAjax.onreadystatechange=function(){
    if(oAjax.readyState==4){
      clearTimeout(timer);
      if(oAjax.status>=200 && oAjax.status<300 || oAjax.status==304){

        options.success && options.success(oAjax.responseText);
      }else{
        options.error && options.error(oAjax.status);
      }
    }
  };

  //5.超时
  if(options.timeout){
    var timer=setTimeout(function(){
      alert('超时了');
      oAjax.abort();//中断ajax请求
    },options.timeout);
  }


}

// ycao新增loadResource
function loadResource(url,cb,cache){
	if(!resources[url]){
		resources[url] = []
		resourcesStatus[url]=0
	}
	resources[url].push(cb)
	if(cache===true){
		if(resourcesStatus[url]==1){
			return;
		}else if(resourcesStatus[url]==2){
			cleanResourceQueue(url);
			return;
		}

	}
	resourcesStatus[url]=1
	var index1=url.lastIndexOf(".")+1;
	var index2=url.length;
	var type = url.substring(index1,index2);
	var newDom = null;
	function loaded(_cb){
		resourcesStatus[url]=2
		setTimeout(function(){
			if(cache===true){
				cleanResourceQueue(url);
				return;
			}else{
				_cb&&_cb()
			}

		},0)

	}
	if(type=="js"){
		newDom = document.createElement("script")
		newDom.setAttribute("type","text/javascript")
		newDom.setAttribute("src", url)
		document.getElementsByTagName("body")[0].appendChild(newDom);
    if (document.all) { //IE
        newDom.onreadystatechange = function() {
            if (newDom.readyState == 'loaded' || newDom.readyState == 'complete') {
								loaded(cb)
            }
        }
    } else {
        newDom.onload = function() {
            loaded(cb)
        }
    }

	}else if(type=="css"){
		newDom = document.createElement("link")
		newDom.setAttribute("rel","stylesheet")
		newDom.setAttribute("type","text/css")
		newDom.setAttribute("href",url)
		document.getElementsByTagName("head")[0].appendChild(newDom)
		cb&&cb()
	}
}

module.exports = {
  send:send,
  ajax:ajax,
  jsonp:getjsonp,
  getjsonp_core:getjsonp_core,
  esAjax: esAjax,
  esJsonp: esJsonp,
  sendGubawebapi:sendGubawebapi,
  loadResource:loadResource
}



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/net.js
// module id = 11
// module chunks = 0